import { render } from "./InstanceTab.vue?vue&type=template&id=5c0b3470&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=5c0b3470&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=5c0b3470&scoped=true&lang=css"

import exportComponent from "/root/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0b3470"]])

export default __exports__